import { FC, useCallback } from "react";
import { ItalicExtension } from "@remirror/extension-italic";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleItalicButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleItalicButton: FC<ToggleItalicButtonProps> = (props) => {
  const { toggleItalic } = useCommands<ItalicExtension>();

  const handleSelect = useCallback(() => {
    if (toggleItalic.enabled()) {
      toggleItalic();
      props.onBlur();
    }
  }, [props, toggleItalic]);

  const active = useActive<ItalicExtension>().italic();
  const enabled = toggleItalic.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleItalic"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
